import React from 'react'
import { useFormApi, RadioGroup } from 'informed'
import { useTranslation } from 'react-i18next'

import { Checkbox, Select, Radio, Text } from 'components/forms'
import Divider from 'components/Divider'
import listCategories from 'sections/category/gql/listCategories'
import listSalesGroups from 'gql/query/listSalesGroups'
import listProductLists from '../gql/query/listProductLists'
import { categoriesOptions } from '../pages/Ingredients/subPages/General'
// import find from 'lodash/find'

const FilterComponent = () => {
	const formApi = useFormApi()
	const [t] = useTranslation()
	const cOptions = categoriesOptions(t)

	return(
		<>
			<Divider visible height={40}/>
			<RadioGroup field='isActive'>
				<Radio label={t('common.strings.all_products')} />
				<Radio value={true} label={t('product_section.fields.active_product')} />
				<Radio value={false} label={t('product_section.fields.inactive_product')} />
			</RadioGroup>
			<Divider visible height={40}/>
			<Checkbox field='includeWawiProducts' label={t('product_section.fields.includeWawiProducts')} />
			<Checkbox field='includeCashassistProducts' label={t('product_section.fields.includeCashassistProducts')} />
			<Divider visible height={40}/>
			<Checkbox field='hasSpecialPrice' label={t('product_section.fields.prices_offers')} />
			<Checkbox
				noForm
				label={t('product_section.fields.groups')}
				checked={formApi?.getValue?.('checkOutCommandId') === 600}
				onChange={e => {
					const isChecked = e.target.checked
					if(isChecked) {
						formApi.setValue('checkOutCommandId', 600)
					} else { // remove checkOutCommandId from filter
						formApi.setValue('checkOutCommandId')
					}
				}}
			/>
			<div><Text field='checkOutCommandId' readOnly hidden /></div>
			<Divider visible height={40}/>
			<Select
				isMulti
				noForm
				field='categoriesHidden'
				value={cOptions.filter(category => formApi?.getValue('categories')?.includes(category.value))}
				label={t('product_section.categories.caption')}
				options={cOptions}
				closeMenuOnSelect={false}
				onChange={val => {
					if (formApi) {
						formApi.setValue('categories', val?.map(e => e.value))
					}
				}}
			/>
			<Text field='categories' readOnly hidden />
			<Select
				field='categoryId'
				label={t('product_section.fields.category')}
				withVirtualBody
				isSearchable
				valueField='id'
				labelField='name'
				isClearable
				removeOnClear
				remoteOptions={{ query: listCategories, variables: { params: { limit: 50 } } }}
			/>
			<Select
				field='salesGroupId'
				label={t('product_section.fields.sales_group')}
				valueField='id'
				labelField='name'
				isClearable
				removeOnClear
				isSearchable
				remoteOptions={{
					additionalOptions: [{ id: null, name: `<${t('product_section.strings.product_no_sales_group')}>` }],
					query: listSalesGroups
				}}
			/>
			<Select
				field='listId'
				label={t('product_section.fields.product_list')}
				valueField='id'
				labelField='name'
				isClearable
				removeOnClear
				remoteOptions={{
					query: listProductLists
				}}
			/>
		</>
	)
}

export default FilterComponent
